
import React, { useState } from 'react'

export const KidNameCmp = ({ addKidName }) => {
  const [kidname, setKidName] = useState('')
  function onChangeInput(event) {
    setKidName(event.target.value)
  }

  function handlerContinuar(kidname) {
    addKidName(kidname)
  }


  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handlerContinuar(event.target.value);
    }
  };


  // useEffect(() => {
  //     console.log('Respuestas actualizadas:', respuestas);
  // }, [respuestas]);


  return (
    <div style={{ marginTop: '-60%'}}>
      <h1 className="text-2xl font-bold mb-10">Dinos. Como se llama tu nene?</h1>
      <div className="flex flex-col items-center">
        
          <input type="text" className="input input-bordered input-lg w-full max-w-xs" placeholder="Escribe aquí tu respuesta..." value={kidname} onChange={onChangeInput} onKeyDown={handleKeyPress}/>
        
        <button disabled={kidname ? false : true} className="btn btn-primary mt-5" onClick={()=>handlerContinuar(kidname)}>Continuar</button>
      </div>
    </div>
  )
}